// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"aae3a447","203":"7805c3cf","453":"966498c2","520":"2b9fbd49","598":"ade145c2","672":"b1ab1893","700":"4b1bc410","811":"0e75fc31","829":"0cdfcdbb","901":"d14df53b"}[chunkId] + ".chunk.js";
};